import { Button, MenuButton } from '@applyboard/crystal-ui'
import { DeleteFillIcon, MoreVertOutlineIcon, EditFillIcon } from '@applyboard/ui-icons'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DeleteApplicationDialog } from '../../../components/Application'
import { StudentApplication } from '../../../components/Application/types'

type DropdownMenuProps = Readonly<{
  application: StudentApplication
  onEditProgram: () => void
  onEditAlternateProgram: () => void
  alternateProgramEnabled: boolean
}>

export function DropdownMenu(props: DropdownMenuProps) {
  const [openMenuButton, setOpenMenuButton] = useState(false)
  const [openDiscardDraftDialog, setOpenDiscardDraftDialog] = useState(false)
  const navigate = useNavigate()
  const menuButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <MenuButton open={openMenuButton} onOpenChange={setOpenMenuButton} alignment="right">
        <MenuButton.Trigger>
          <Button
            ref={menuButtonRef}
            aria-label="Open menu"
            leadIcon={MoreVertOutlineIcon}
            emphasis="highlighted"
          />
        </MenuButton.Trigger>
        <MenuButton.Button
          id="modify-program"
          icon={EditFillIcon}
          onClick={() => props.onEditProgram()}
        >
          Edit Program Selection
        </MenuButton.Button>
        {props.alternateProgramEnabled ? (
          <MenuButton.Button
            id="modify-alternate-program"
            icon={EditFillIcon}
            onClick={() => props.onEditAlternateProgram()}
          >
            Edit Alternate Program
          </MenuButton.Button>
        ) : null}
        <MenuButton.Button
          id="discard-draft"
          icon={DeleteFillIcon}
          onClick={() => setOpenDiscardDraftDialog(true)}
        >
          Discard Draft
        </MenuButton.Button>
      </MenuButton>

      <DeleteApplicationDialog
        focusRef={menuButtonRef}
        open={openDiscardDraftDialog}
        onOpenChange={setOpenDiscardDraftDialog}
        applicationId={props.application.id}
        onSuccess={() => {
          navigate('/', { replace: true, state: props.application })
        }}
      />
    </>
  )
}
